import type { ListItemKind } from './listItem';

const BOTH_KINDS: readonly ListItemKind[] = ['activity', 'issue'];

/**
 * What a failed feed takes from the list in view. The list draws on two
 * sources — the activities and the issues — and its kind scope may ask for one
 * of them only (`types`, empty = both). `'all'` when every source in scope
 * failed (the list has nothing to show but the outage), the one failed kind
 * when the other still shows (the list stays, with a note naming what's
 * missing), `null` when nothing in scope failed — an issues-only list doesn't
 * go dark because the activities did.
 */
export function sourceOutage(
  failed: Readonly<Record<ListItemKind, boolean>>,
  types: readonly ListItemKind[],
): 'all' | ListItemKind | null {
  const inScope = types.length > 0 ? types : BOTH_KINDS;
  const down = inScope.filter((kind) => failed[kind]);
  if (down.length === 0) return null;
  return down.length === inScope.length ? 'all' : down[0]!;
}
